import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";
import { obtenerSesion } from "./sesionSeguridad";

const empresa = () => obtenerSesion()?.EmpresaId || 0;
const post = (endpoint, payload = {}) => _Componentes_WebApiCalls_Post(endpoint, {
  ...payload,
  EmpresaId: empresa(),
});

export const listarUsuarios = (Busqueda = "", SoloActivos = false) =>
  post("security/usuarios/listar", { Busqueda, SoloActivos });

export const crearUsuario = ({ Mail, PassWord, Nombre, Apellido, BaseDatos = "" }) =>
  post("PISeunLogin/InsertLocal", { Mail, PassWord, Nombre, Apellido, BaseDatos });

export const listarRolesUsuario = (OperadorId) =>
  post("security/usuarios/roles/listar", { OperadorId });

export const cambiarEstadoUsuario = (OperadorId, Activo) =>
  post("security/usuarios/estado", { OperadorId, Activo });

export const resetearClaveUsuario = (OperadorId, NuevaClave) =>
  post("security/usuarios/resetear-clave", { OperadorId, NuevaClave });

export const listarRoles = () => post("security/roles/listar");

export const guardarRol = ({ Id = 0, Codigo, Nombre, Activo = true, EsAdministrador = false, Permisos = [] }) =>
  post("security/roles", { Id, Codigo, Nombre, Activo, EsAdministrador, Permisos });

export const listarPermisosRol = (RolId) =>
  post("security/roles/permisos/listar", { RolId });

export const guardarRolesUsuario = (OperadorId, Cambios) =>
  post("security/operadores/roles", { OperadorId, Cambios });

export const extraerLista = (respuesta) => respuesta?.data?.Lista || respuesta?.data?.lista || [];
